import React from 'react';
import { string, bool, func } from 'prop-types';

import { INTERCOM_LAUNCHER_LINK_CLASS, INTERCOM_REQUEST_OFFER_CLASS } from 'ggApp/modules/intercom';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import Typography from 'ggApp/shared/components/typography';
import { AuthModal, FLOW_NAMES } from 'ggApp/modules/auth/v3';
import { getHIWPageUrl } from 'ggApp/utils/path';

import { Wrap, Link, Languages, Stores, Button } from './styled';

export default class Options extends React.PureComponent {
    createAuthModalRef = (authModal) => {
        this.authModal = authModal;
    };

    openAuthModal = () => {
        if (this.authModal) {
            this.authModal.openModal();
        }
    };

    render() {
        const {
            className,
            faqsLink,
            contactLink,
            isLoggedIn,
            authTK,
            logout,
            closeMenu,
            countryCode,
            storeCode,
            activeLanguage,
            isPartner,
            isBusinessStore,
            requestOfferEnabled,
            newReferralsHostFeatureFlag,
        } = this.props;
        let hiwCode = storeCode;
        let external = false;
        if (isPartner) {
            hiwCode = countryCode;
            external = true;
        }
        return (
            <Wrap className={className}>
                {!storeCode.startsWith('business_') ? (
                    <>
                        <Button type="button" onClick={isLoggedIn ? logout : this.openAuthModal}>
                            <Typography tag="label">
                                <Translator tk={authTK} />
                            </Typography>
                        </Button>
                        <Link
                            external={external}
                            to={getHIWPageUrl(hiwCode, activeLanguage)}
                            onClick={closeMenu}
                        >
                            <Typography tag="label">
                                <Translator tk="TIPS_LINKS_HIW_TEXT" />
                            </Typography>
                        </Link>
                        {requestOfferEnabled && (
                            <Button className={INTERCOM_REQUEST_OFFER_CLASS}>
                                <Typography tag="label">
                                    <Translator tk="OFFERINGS_LINKS_REQUEST_OFFER_TEXT" />
                                </Typography>
                            </Button>
                        )}
                        {!isBusinessStore && storeCode !== 'us' && (
                            <Link
                                external={false}
                                to={newReferralsHostFeatureFlag ? '/referrals' : '/invite-friend'}
                                onClick={closeMenu}
                            >
                                <Typography tag="label">
                                    <Translator tk="PROFILE_LINKS_REFERRALS_TEXT" />
                                </Typography>
                            </Link>
                        )}
                        <Link external to={faqsLink} onClick={closeMenu}>
                            <Typography tag="label">
                                <Translator tk="FAQ_BUTTON_TEXT" />
                            </Typography>
                        </Link>
                    </>
                ) : null}
                <Link
                    external
                    to={contactLink}
                    className={INTERCOM_LAUNCHER_LINK_CLASS}
                    onClick={closeMenu}
                >
                    <Typography tag="label">
                        <Translator tk="CONTACT_BUTTON_TEXT" />
                    </Typography>
                </Link>
                <Languages minimal />
                <Stores minimal />
                <AuthModal modalRef={this.createAuthModalRef} flow={FLOW_NAMES.SIGN_IN} />
            </Wrap>
        );
    }
}

Options.propTypes = {
    className: string,
    faqsLink: string,
    contactLink: string,
    authTK: string,
    isLoggedIn: bool,
    logout: func,
    countryCode: string,
    storeCode: string,
    activeLanguage: string,
    isPartner: bool,
    requestOfferEnabled: bool,
};

Options.defaultProps = {
    className: '',
    faqsLink: '',
    contactLink: '',
    authTK: '',
    isLoggedIn: false,
    logout: () => {},
    countryCode: '',
    storeCode: '',
    activeLanguage: '',
    isPartner: false,
    requestOfferEnabled: false,
};
